/**
 * Lazy loaders for this package's translation files, keyed by language.
 *
 * Consumers used to `import()` these JSON files by path. That worked while the
 * package was installed under node_modules and Vite externalised it, letting
 * node's ESM loader receive the `with: { type: 'json' }` attribute. Now that
 * the package is consumed from source, Vite resolves the import itself and a
 * fully-dynamic specifier is handed to node without that attribute, which node
 * rejects (ERR_IMPORT_ATTRIBUTE_MISSING) during SSR.
 *
 * `import.meta.glob` is resolved statically by Vite instead, so each language
 * stays a separate lazily-fetched chunk and no runtime attribute is involved.
 */
const translationModules = import.meta.glob('./*.json');

const DEFAULT_LANGUAGE = 'en';

/**
 * Loads the translation messages for a language, falling back to English when
 * the language has no translation file.
 *
 * @param {string} language  The language code to load (e.g. 'en', 'fr').
 *
 * @returns {Promise<Object>} The translation messages.
 */
async function loadTranslations(language) {

	const load = translationModules[`./${language}.json`]
		|| translationModules[`./${DEFAULT_LANGUAGE}.json`];

	if (!load) {
		return {};
	}

	const module = await load();

	return module.default || module;

}

export {
	loadTranslations,
};
